module.exports = __webpack_public_path__ + "img/sld_mfm_ic_3_t1_b1_dark.323fcbf9.svg";